import { motion } from "framer-motion";
import {
  Wrapper,
  Section,
  HeaderTitle,
  GradientLine,
  HeroLine,
  Lead,
  PrimaryBtn,
  HeroUnderline,
} from "./Hero.styled";

export default function Hero() {
  return (
    <Wrapper>
      <Section>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <HeaderTitle>
            <GradientLine>The digital transformation platform</GradientLine>
            <HeroLine>for the construction sector</HeroLine>
          </HeaderTitle>
        </motion.div>
        <Lead>
          <strong>Portal 360</strong> by <strong>Piersoft Technologies</strong>{" "}
          brings together planning, procurement, mobility, security, and
          paperless operations. This helps your sites move faster, stay
          compliant, and remain in control.
        </Lead>

        <PrimaryBtn href="#features">Explore features</PrimaryBtn>
        {/* <motion.div
          initial={{ scaleX: 0, opacity: 0 }}
          whileInView={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        > */}
        <HeroUnderline />
        {/* </motion.div> */}
      </Section>
    </Wrapper>
  );
}
